import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core"
import { useSelector } from "react-redux"
import { formatDinero } from "../../../../utils/formatDinero"
const TablaContrato = () => {
    const {cotizacion} = useSelector(store => store.cambios)
    return (
        <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">Item</TableCell>
                    <TableCell align="center">Monto unitario</TableCell>
                    <TableCell align="center">Cantidad</TableCell>
                    <TableCell align="center">Monto</TableCell>
                    <TableCell align="center">Moneda</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    cotizacion.PaqueteContratado?.ListaSuplementoContratado.map((item, index) => {
                        return (
                            <TableRow key={item.IdObjeto}>
                                <TableCell align="center">{`${item.TipoSuplemento} / ${item.Nombre}`}</TableCell>
                                <TableCell align="center">{formatDinero(item.Precio)}</TableCell>
                                <TableCell align="center">{item.Cantidad}</TableCell>
                                <TableCell align="center">{formatDinero(item.Precio * item.Cantidad)}</TableCell>
                                <TableCell align="center">{cotizacion.Moneda}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </Table>
    </TableContainer>
    )
}
export default TablaContrato